import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { CHAT_IA_INIT, CHAT_IA_GET_HISTORICO_INIT } from '../actionTypes';
import { chatIaSuccess, chatIaError, chatIaGetHistoricoSuccess } from './actions';
import { enviarPromptIA, recuperarUltimasMsgs } from '../../integracoes/servicos/mongo-atlas/funcoes/chatIA';
import { FarmaError } from '../../integracoes/modelos/erros';

export const fetchChatIa = async (payload: any) => {
    try {
        const { status, dados, mensagem } = await enviarPromptIA(payload);
        if (status) {
            return {
                isSuccess: true,
                data: dados,
                msg: mensagem
            };
        } else {
            return { isSuccess: false, msg: mensagem, data: null };
        }
    } catch (error: any) {
        throw new FarmaError(error);
    }
};

function* parseChatIa({ payload }: any) {
    try {
        const { isSuccess, data, msg } = yield call(fetchChatIa, payload);
        if (isSuccess) {
            yield put(chatIaSuccess({ response: data }));
        } else {
            yield put(chatIaError({ error: msg }));
        }
    } catch (error: any) {
        yield put(
            chatIaError({
                error: error.mensagem ? `${error.mensagem}` : `${error.message}`
            })
        );
    }
}

export function* watchChatIa() {
    yield takeEvery(CHAT_IA_INIT, parseChatIa);
}

export const fetchHistorico = async (userId: string) => {
    try {
        const { status, dados, mensagem } = await recuperarUltimasMsgs(userId);
        if (status) {
            return {
                isSuccess: true,
                data: dados,
                msg: mensagem
            };
        } else {
            return { isSuccess: false, msg: mensagem, data: null };
        }
    } catch (error: any) {
        throw new FarmaError(error);
    }
};

function* parseHistorico({ payload }: any) {
    try {
        const { isSuccess, data, msg } = yield call(fetchHistorico, payload);
        if (isSuccess) {
            yield put(chatIaGetHistoricoSuccess({ historico: data }));
        } else {
            yield put(chatIaError({ error: msg }));
        }
    } catch (error: any) {
        yield put(
            chatIaError({
                error: error.mensagem ? `${error.mensagem}` : `${error.message}`
            })
        );
    }
}

export function* watchHistorico() {
    yield takeEvery(CHAT_IA_GET_HISTORICO_INIT, parseHistorico);
}

export default function* rootSaga() {
    yield all([
        fork(watchChatIa),
        fork(watchHistorico)
    ]);
}
